import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';

const Brand_tab_Employees: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/UserDefinedFields/ByUserDefinedFieldCategory/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    return (
        <DataTable
            name='dtUserDefinedFieldCategoryUserDefinedFields'
            colInfos={[
                { key: true, dataProp: 'Id', visible: false },
                { title: 'Name', dataProp: 'name' },
                { title: 'Data type', dataProp: 'dataType' },
                { title: 'Type', dataProp: 'userDefinedFieldType' },
            ]}
            tableData={data}
            navigateTitle='User defined field'
            navigateUrl='/plm/ItemSetup/UserDefinedField/'
        />
    );
}
export default Brand_tab_Employees;